import type { GTableAlimentBase, GTableBoxPaddingBase, GTableHeaderProps } from './types';
import type { ReactNode } from 'react';

import { GTableProvider } from '~/presentation/ui';
import { Header, Cell, Row } from './components';
import { Card, Box } from '@shopify/polaris';
import { useMemo } from 'react';
import { cls } from '~/utils';

export interface GTableBaseProps {
  listHeader: GTableHeaderProps[];
  items: any[];
  children?: ReactNode;
  paddingTable?: GTableBoxPaddingBase;
  paddingRow?: GTableBoxPaddingBase;
  paddingCell?: GTableBoxPaddingBase;
  classRemoved?: boolean;
  onClick?: (e?: React.MouseEvent) => void;
}

export const GTable = ({
  listHeader,
  children,
  classRemoved,
  onClick,
  ...props
}: GTableBaseProps) => {
  const defaultPaddingTable: GTableBoxPaddingBase = { paddingBlock: '400', paddingInline: '400' };
  const paddingTable = props.paddingTable
    ? { ...defaultPaddingTable, ...props.paddingTable }
    : defaultPaddingTable;

  const columnHead = useMemo(() => {
    return listHeader
      .map((heading) => {
        if (heading.isFlushLeft) return '';

        return heading.width ?? 'minmax(0, 1fr)';
      })
      .join(' ');
  }, [listHeader]);

  const columnBody = useMemo(() => {
    return listHeader
      .map((heading) => {
        return heading.width ?? 'minmax(0, 1fr)';
      })
      .join(' ');
  }, [listHeader]);

  const alignments: GTableAlimentBase[] = useMemo(() => {
    return listHeader.map((heading) => heading.alignment ?? 'start');
  }, [listHeader]);

  return (
    <GTableProvider
      columnHead={columnHead}
      columnBody={columnBody}
      alignments={alignments}
      listHeader={listHeader}
    >
      <Card padding={'0'}>
        <div
          className={`${cls({
            'cursor-pointer': !!onClick,
            'Polaris-GTable': !classRemoved,
          })}`}
          onClick={onClick}
        >
          <Box {...paddingTable}>
            <div
              className={`${cls({
                'Polaris-GTable-Container': !classRemoved,
              })}`}
            >
              <GTable.Row mode="head">
                <Header />
              </GTable.Row>
              {children}
            </div>
          </Box>
        </div>
      </Card>
    </GTableProvider>
  );
};

GTable.Row = Row;
GTable.Cell = Cell;

// {...(isHighlighted
//             ? { borderColor: 'border-inverse-active' }
//             : { borderColor: 'border-disabled' })}
//           borderWidth="050"
//           borderRadius="300"
